export default __webpack_public_path__ + "static/media/franchise-template-2-fr.d51ec04f.svg";